module.exports = {
    pt_BR: {
        $vuetify: {
            dataTable: {
                rowsPerPageText: 'Linhas por página:',
                pageText: '{0}-{1} av {2}'
            },
            dataIterator: {
                pageText: '{0}-{1} de {2}',
                noResultsText: 'Não foram encontrados resultados para a pesquisa',
                nextPage: 'Proxima página',
                prevPage: 'Anterior',
                rowsPerPageAll: 'Itens por página'
            },
            noDataText: 'Não existem dados para serem exibidos',
        }
    }
}